import {
  OuiCenterComponent,
  OuiGridComponent,
  OuiStackComponent,
  OuiTextComponent,
} from '@aiz-gl/omni-ui';

import { Component, computed, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { DownloadButtonComponent } from '../../components/download-button/download-button.component';
import { PageComponent } from '../../components/page/page';
import { BuyerManagementService } from '../../services/buyer-management/buyer-management.service';
import { EcommerceService } from '../../services/ecommerce/ecommerce.service';
import { LincLoginReportService } from '../../services/linc-login-report/linc-login-report.service';
import { BasePageComponent } from '../base/base.component';

@Component({
  selector: 'app-download',
  standalone: true,
  imports: [
    OuiStackComponent,
    DownloadButtonComponent,
    OuiTextComponent,
    OuiGridComponent,
    OuiCenterComponent,
    PageComponent,
    RouterLink,
  ],
  templateUrl: './download.component.html',
})
export class DownloadsPage extends BasePageComponent {
  readonly buyerService = inject(BuyerManagementService);
  readonly ecommerceService = inject(EcommerceService);
  readonly lincLoginReportService = inject(LincLoginReportService);

  private generateDownloadFileName(prefix: string): string {
    return ['ATB', prefix, new Date().toISOString().slice(0, 10)]
      .join('_')
      .replace('__', '_');
  }

  readonly buyerDownloadFileName = computed(() =>
    this.generateDownloadFileName('Buyer'),
  );

  readonly shippingRatesDownloadFileName = computed(() =>
    this.generateDownloadFileName('ShippingRates'),
  );

  readonly taxRatesFileName = computed(() =>
    this.generateDownloadFileName('TaxRates'),
  );

  readonly currencyConversionFileName = computed(() =>
    this.generateDownloadFileName('CurrencyConversion'),
  );

  readonly lincLoginReportFileName = computed(() =>
    this.generateDownloadFileName('LincLoginReport'),
  );
}
